// Vendors
import React from 'react'

// Components
import ReactApexChart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts'

// Styles
import { Box, Text } from '@chakra-ui/react'

// Interfaces
export interface ISeries {
  name: string
  data: number[]
}

export interface IGraphStacks {
  title: string
  subtitle: string
  options?: ApexOptions
  series?: ISeries[]
}

const DEFAULT_OPTIONS: ApexOptions = {
  chart: {
    type: 'bar',
    stacked: true,
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: true,
    },
  },
  stroke: {
    width: 1,
    colors: ['#fff'],
  },
  xaxis: {
    categories: [
      'JAN',
      'FEV',
      'MAR',
      'ABR',
      'MAI',
      'JUN',
      'JUL',
      'AGO',
      'SET',
      'OUT',
      'NOV',
      'DEZ',
    ],
    labels: {
      show: false,
    },
  },
  yaxis: {
    title: {
      text: undefined,
    },
  },
  fill: {
    opacity: 1,
  },
  dataLabels: {
    enabled: true,
  },
  legend: {
    position: 'bottom',
    horizontalAlign: 'center',
    offsetX: 40,
  },
}

export const GraphStacks: React.FC<IGraphStacks> = (props) => {
  /*
  |-----------------------------------------------------------------------------
  | Constants
  |-----------------------------------------------------------------------------
  |
  |
  */
  const { title, subtitle, options, series } = props
  /*
  |-----------------------------------------------------------------------------
  | States
  |-----------------------------------------------------------------------------
  |
  |
  */

  /*
  |-----------------------------------------------------------------------------
  | Functions
  |-----------------------------------------------------------------------------
  |
  |
  */

  /*
  |-----------------------------------------------------------------------------
  | Renders
  |-----------------------------------------------------------------------------
  |
  |
  */
  return (
    <Box
      bg={'white'}
      shadow="base"
      rounded="lg"
      px={4}
      py={6}
      position="relative"
    >
      <Text as={'h2'} fontSize="lg" fontWeight="bold" color={'blue.500'}>
        {title}
      </Text>
      <Text as={'p'} fontSize="md" color={'gray.500'} pt={2}>
        {subtitle}
      </Text>
      <ReactApexChart
        series={series}
        type="bar"
        height={500}
        options={{ ...DEFAULT_OPTIONS, ...options }}
      />
    </Box>
  )
}
